import React from 'react';

import logoSisaf from '../../assets/logo_tipo.png';

interface HeaderProps {
  nomeCompleto: string;
  template: string;
}

const Header: React.FC<HeaderProps> = ({ nomeCompleto, template }) => {
  return (
    <header
      className="header"
      style={{
        borderBottom: '1px solid #ddd',
        paddingBottom: '10px',
        marginBottom: '20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={logoSisaf}
            alt="Logo Sisaf"
            style={{ height: '16px', marginRight: '5px' }}
            onError={(e) => (e.currentTarget.style.display = 'none')}
          />
        </div>

        {/* Título e módulo */}
        <div style={{ textAlign: 'left', flex: 2 }}>
          <h1
            style={{
              fontSize: '14px',
              margin: 0,
              textAlign: 'left',
            }}
          >
            <b>SisAF</b> - {template}
          </h1>
        </div>

        {/* Informações do Relatório */}
        <div style={{ textAlign: 'right', fontSize: '12px', color: '#777' }}>
          <div style={{ marginBottom: '5px' }}>
            {nomeCompleto}
            {' - '}
            {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
